import { render, staticRenderFns } from "./OfficialActiveActivity.vue?vue&type=template&id=4bf298d6&scoped=true"
import script from "./OfficialActiveActivity.vue?vue&type=script&lang=js"
export * from "./OfficialActiveActivity.vue?vue&type=script&lang=js"
import style0 from "./OfficialActiveActivity.vue?vue&type=style&index=0&id=4bf298d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf298d6",
  null
  
)

export default component.exports